module.exports = require("@swa-ui/vacations/src/VacationsPackagesPlacement/PackageCard/PackageCard.module.scss");